import React from "react";
import cx from "clsx";
import moment from "moment";
import styles from "./styles.module.scss";
import { useCurrentUserQuery } from "../../../../api/queries/useUserQuery";
import { DEFAULT_DATE_FORMAT } from "../../../../consts/general";

export function Info({
  questionnaireType,
  questionnaireName,
  patientName,
  patientDob,
  completionDate,
  providerName,
  className,
}) {
  const { data: user } = useCurrentUserQuery();

  const formatDate = (d) =>
    moment.utc(d).format(user?.dateFormat || DEFAULT_DATE_FORMAT);

  return (
    <div className={cx(styles.root, className)}>
      <div>
        <b>
          {questionnaireType} - {questionnaireName}
        </b>
        <div>
          {patientName} - DOB: {formatDate(patientDob)}
        </div>
      </div>
      <div>
        <b>Date: {completionDate ? formatDate(completionDate) : "N/A"}</b>
        <div>Provider: {providerName || "N/A"}</div>
      </div>
    </div>
  );
}
